import { useCallback, useEffect, useState } from "react";

import { ViewMode } from "../ViewToggle";

const VIEW_MODE_STORAGE_KEY = "unifiedRegistry.viewMode";

export const useViewMode = (defaultMode: ViewMode = "grid") => {
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    if (typeof window === "undefined") {
      return defaultMode;
    }

    const stored = localStorage.getItem(VIEW_MODE_STORAGE_KEY);
    if (stored === "grid" || stored === "list") {
      return stored;
    }
    return defaultMode;
  });

  useEffect(() => {
    localStorage.setItem(VIEW_MODE_STORAGE_KEY, viewMode);
  }, [viewMode]);

  const toggleViewMode = useCallback(() => {
    setViewMode(prev => (prev === "grid" ? "list" : "grid"));
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return;
      }

      if (e.altKey && e.key === "v") {
        e.preventDefault();
        toggleViewMode();
      }

      if (e.altKey && e.key === "g") {
        e.preventDefault();
        setViewMode("grid");
      }

      if (e.altKey && e.key === "l") {
        e.preventDefault();
        setViewMode("list");
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [toggleViewMode]);

  return {
    viewMode,
    setViewMode,
    toggleViewMode,
  };
};
